<div class="app-overlay" *ngIf="open" (click)="onBackdrop($event)">
  <div class="app-dialog" role="dialog" aria-modal="true" aria-labelledby="composeHeading">
    <div class="dialog-header-row">
      <div class="dialog-header-content">
        <h2 id="composeHeading" class="govuk-heading-m govuk-!-margin-bottom-2">Nová správa</h2>
      </div>
      <button type="button" class="close-icon-button" (click)="onCancel()" aria-label="Zavrieť dialóg">
        <img src="assets/icons/close.svg" alt="" width="24" height="24">
      </button>
    </div>

    <form (ngSubmit)="submit()" novalidate>
      <!-- Recipient -->
      <div class="govuk-form-group" [class.govuk-form-group--error]="touched && !recipientId">
        <label class="govuk-label" for="to">Adresát</label>
        <select id="to" class="govuk-select" [(ngModel)]="recipientId" name="recipientId" required (ngModelChange)="onFormChange()" (blur)="onFieldBlur()">
          <option value="" disabled selected>— Vyberte adresáta —</option>
          <option *ngFor="let r of recipients" [value]="r.id">{{ r.name }}, {{ r.ico }}</option>
        </select>
        <p class="govuk-error-message" *ngIf="touched && !recipientId">
          <span class="govuk-visually-hidden">Chyba:</span> Vyberte adresáta.
        </p>
      </div>

      <!-- Subject -->
      <div class="govuk-form-group" [class.govuk-form-group--error]="touched && !subject.trim()">
        <label class="govuk-label" for="subject">Predmet</label>
        <input id="subject" class="govuk-input" type="text" [(ngModel)]="subject" name="subject" required
          maxlength="255"
          (keydown.enter)="$event.preventDefault()"
          (ngModelChange)="onFormChange()"
          (blur)="onFieldBlur()"
          (focus)="onSubjectFocus()"
          (click)="onSubjectClick()">
        <p class="govuk-error-message" *ngIf="touched && !subject.trim()">
          <span class="govuk-visually-hidden">Chyba:</span> Predmet je povinný.
        </p>
      </div>

      <!-- Body -->
      <div class="govuk-form-group" [class.govuk-form-group--error]="touched && !body.trim()">
        <label class="govuk-label" for="body">Text správy</label>
        <textarea id="body" class="govuk-textarea" rows="10" [(ngModel)]="body" name="message"
          placeholder="Sem napíšte text správy" (ngModelChange)="onFormChange()" (blur)="onFieldBlur()" required></textarea>
        <p class="govuk-error-message" *ngIf="touched && !body.trim()">
          <span class="govuk-visually-hidden">Chyba:</span> Text správy je povinný.
        </p>
      </div>

      <!-- Form signing choice -->
      <div class="govuk-form-group">
        <label class="app-sign-inline-label">
          <input type="checkbox" class="app-sign-checkbox"
                 [(ngModel)]="signForm" name="signFormCheckbox"
                 [disabled]="signSelectionLocked">
          Podpísať formulár správy (GeneralAgenda.xml)
        </label>
        <strong *ngIf="formSigned" class="govuk-tag govuk-tag--green govuk-!-margin-left-2">PODPÍSANÉ</strong>
        <div class="govuk-hint govuk-!-margin-top-1">
          Formulár je generovaný automaticky z predmetu a textu správy.
        </div>
      </div>

      <!-- Attachments -->
      <div class="govuk-form-group">
        <label class="govuk-label" for="fileInput">Prílohy</label>
        <p class="govuk-hint govuk-!-margin-bottom-2 hide-on-mobile" *ngIf="attachments.length === 0">
          Presuňte súbory do oblasti nižšie alebo ich vyberte tlačidlom. Môžete pridať viac súborov.
        </p>
        <p class="govuk-hint govuk-!-margin-bottom-2 show-on-mobile" *ngIf="attachments.length === 0">
          Vyberte súbory tlačidlom. Môžete pridať viac súborov.
        </p>

        <!-- Drop area -->
        <div class="app-dropzone govuk-!-margin-bottom-2" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
          <span *ngIf="attachments.length === 0">Presuňte súbory sem</span>
          <span *ngIf="attachments.length > 0">Presuňte ďalšie súbory sem</span>
        </div>

        <!-- File picker -->
        <!-- The label wraps the hidden input so that a direct tap on the label triggers
             the native file-chooser even when programmatic .click() is blocked by
             Android WebView's user-gesture sandbox. The govuk-button-styled label
             gives the same visual appearance as a regular button. -->
        <div>
          <label for="fileInput"
                 class="govuk-button govuk-button--secondary"
                 [class.disabled]="sending()"
                 [attr.aria-disabled]="sending() || null"
                 style="cursor: pointer; display: inline-block;">
            {{ attachments.length === 0 ? 'Vybrať súbory' : 'Pridať ďalší súbor' }}
          </label>
          <!-- accept="*/*" is explicit so Android's intent chooser opens the full file manager
               rather than only the camera or a single app. multiple allows batch selection. -->
          <input id="fileInput" #fileInput type="file" multiple accept="*/*"
                 (change)="onFileInputChange($event)"
                 class="hidden-file-input"
                 [disabled]="sending()" />
        </div>

        <!-- Selected files list with signing selection -->
        <div *ngIf="attachments.length > 0" class="govuk-!-margin-top-3">
          <h3 class="govuk-heading-s govuk-!-margin-bottom-2">Pridané prílohy</h3>
          <table class="govuk-table app-attachments-table">
            <thead class="govuk-table__head">
              <tr class="govuk-table__row">
                <th scope="col" class="govuk-table__header app-sign-col">
                  <label class="app-sign-all-label" title="Podpísať všetky prílohy">
                    <input type="checkbox" class="app-sign-checkbox"
                           [checked]="allSignSelected"
                           [indeterminate]="someSignSelected && !allSignSelected"
                           (change)="toggleSignAll($any($event.target).checked)"
                           [disabled]="signSelectionLocked">
                    Podpísať
                  </label>
                </th>
                <th scope="col" class="govuk-table__header">Názov súboru</th>
                <th scope="col" class="govuk-table__header app-size-col">Veľkosť</th>
                <th scope="col" class="govuk-table__header app-action-col">Akcia</th>
              </tr>
            </thead>
            <tbody class="govuk-table__body">
              <tr *ngFor="let a of attachments; let i = index" class="govuk-table__row">
                <td class="govuk-table__cell app-sign-col">
                  <input type="checkbox" class="app-sign-checkbox"
                         [(ngModel)]="a.sign" [name]="'signAtt' + i"
                         [disabled]="signSelectionLocked || !!a.error"
                         [attr.aria-label]="'Podpísať ' + a.file.name">
                  <span class="show-on-mobile app-attachment-meta">Podpísať</span>
                </td>
                <td class="govuk-table__cell">
                  <span class="app-attachment-name">{{ a.file.name }}</span>
                  <strong *ngIf="a.signed" class="govuk-tag govuk-tag--green govuk-!-margin-left-2">PODPÍSANÉ</strong>
                  <div class="govuk-hint govuk-!-margin-top-1" *ngIf="a.error">{{ a.error }}</div>
                </td>
                <td class="govuk-table__cell app-size-col">
                  <span class="app-attachment-meta">{{ a.file.size | number }} B</span>
                </td>
                <td class="govuk-table__cell app-action-col">
                  <button type="button" class="govuk-button govuk-button--secondary govuk-button--small"
                    (click)="removeAttachment(i)" [disabled]="sending()">
                    Odstrániť
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p class="govuk-hint govuk-!-margin-top-2" *ngIf="!hasSignSelection && !signSelectionLocked">
          Nie je vybraný žiadny dokument na podpísanie — správu môžete odoslať nepodpísanú,
          alebo vyberte dokumenty na podpis.
        </p>
      </div>

      <div class="app-actions govuk-!-margin-top-4">
        <!-- Hidden deeplink anchor for mobile compatibility -->
        <a #deeplinkAnchor [href]="deeplink || ''" target="_blank" style="display: none;"></a>
        
        <!-- First button: Prepare for signing -->
        <button *ngIf="!currentJobId && !signingInProgress() && !signedSuccessfully()"
                type="button"
                class="govuk-button"
                (click)="onPrepareSign()"
                [disabled]="sending() || savingDraft() || !hasSignSelection">
          {{ savingDraft() ? 'Ukladám...' : sending() ? 'Pripravujem...' : 'Pripraviť na podpis' }}
        </button>
        
        <!-- Second button: Sign (with deeplink) -->
        <button *ngIf="currentJobId && deeplink && !signingInProgress() && !signedSuccessfully()" 
                type="button" 
                class="govuk-button" 
                (click)="onSignClick($event)" 
                [disabled]="sending() || savingDraft()">
          Podpísať
        </button>
        
        <!-- Status message while signing is in progress -->
        <div *ngIf="signingInProgress()" class="govuk-inset-text govuk-!-margin-top-2" style="background-color: #f3f7fb; border-left: 4px solid #005ea5;">
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <p class="govuk-body govuk-!-margin-bottom-0">
              <span class="hourglass-animation">
                <img src="assets/icons/hourglass_top.svg" class="hourglass-icon hourglass-top" alt="" />
                <img src="assets/icons/hourglass_bottom.svg" class="hourglass-icon hourglass-bottom" alt="" />
              </span>
              Čakám na dokončenie podpisu...
            </p>
            <button type="button" 
                    class="govuk-button govuk-button--secondary govuk-!-margin-bottom-0" 
                    style="margin-left: 15px;"
                    (click)="cancelSigning()">
              Zrušiť podpis
            </button>
          </div>
        </div>

        <!-- Success indicator after signing completes -->
        <div *ngIf="signedSuccessfully()" class="govuk-inset-text govuk-!-margin-top-2 success-indicator">
          <p class="govuk-body">✅ Dokument bol úspešne podpísaný. Môžete odoslať správu.</p>
        </div>

        <!-- Partial signature indicator (some signatures removed or only some documents signed) -->
        <div *ngIf="!signedSuccessfully() && anySigned && !signingInProgress()" class="govuk-inset-text govuk-!-margin-top-2">
          <p class="govuk-body">
            Podpísaná je len časť dokumentov. Nepodpísané dokumenty môžete pripraviť na podpis,
            alebo správu odoslať tak, ako je.
          </p>
        </div>

        <!-- Remove signature button (visible while at least one document is signed) -->
        <button *ngIf="anySigned"
                type="button"
                class="govuk-button govuk-button--secondary"
                (click)="onRemoveSignature()"
                [disabled]="sending() || savingDraft() || signingInProgress()">
          Odstrániť podpis
        </button>

        <!-- Send button (enabled after successful signing or for unsigned messages) -->
        <button type="submit" 
                class="govuk-button govuk-button--secondary" 
                [disabled]="sending() || savingDraft() || signingInProgress()">
          {{ sending() ? 'Odosielam…' : savingDraft() ? 'Ukladám...' : 'Odoslať' }}
        </button>
        
        <!-- Delete draft button (only visible when editing existing draft) -->
        <button *ngIf="draftId !== null" 
                type="button" 
                class="govuk-button govuk-button--warning" 
                (click)="onDeleteDraft()"
                [disabled]="sending() || signingInProgress()">
          Zahodiť
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Error popup (independent of compose dialog) -->
<div class="app-overlay app-overlay--notification" *ngIf="showErrorDialog" (click)="onErrorBackdrop($event)">
  <div class="app-dialog app-dialog--notification" role="alertdialog" aria-modal="true" aria-labelledby="errorHeading">
    <h2 id="errorHeading" class="govuk-heading-m govuk-!-margin-bottom-2">Chyba</h2>
    <p class="govuk-body">{{ error() }}</p>

    <div class="app-actions govuk-!-margin-top-4">
      <button type="button" class="govuk-button" autofocus (click)="dismissError()">Zatvoriť</button>
    </div>
  </div>
</div>

<!-- Confirmation dialog for sending unsigned documents -->
<div class="app-overlay app-overlay--notification" *ngIf="showConfirmDialog" (click)="onConfirmBackdrop($event)">
  <div class="app-dialog app-dialog--notification" role="alertdialog" aria-modal="true" aria-labelledby="confirmHeading">
    <h2 id="confirmHeading" class="govuk-heading-m govuk-!-margin-bottom-2">Potvrdenie odoslania</h2>
    <p class="govuk-body">{{ confirmMessage() }}</p>

    <div class="app-actions govuk-!-margin-top-4">
      <button type="button" class="govuk-button govuk-button--warning" (click)="confirmSendUnsigned()">
        Odoslať nepodpísaný
      </button>
      <button type="button" class="govuk-button govuk-button--secondary" autofocus (click)="cancelSendUnsigned()">
        Pokračovať v podpisovaní
      </button>
    </div>
  </div>
</div>

<!-- Success popup (independent of compose dialog) -->
<div class="app-overlay app-overlay--notification" *ngIf="showSuccessDialog" (click)="onSuccessBackdrop($event)">
  <div class="app-dialog app-dialog--notification" role="dialog" aria-modal="true" aria-labelledby="successHeading">
    <h2 id="successHeading" class="govuk-heading-m govuk-!-margin-bottom-2">Úspech</h2>
    <p class="govuk-body">{{ success() }}</p>

    <div class="app-actions govuk-!-margin-top-4">
      <button type="button" class="govuk-button" autofocus (click)="dismissSuccess()">Zatvoriť</button>
    </div>
  </div>
</div>

<!-- Cancel confirmation dialog -->
<div class="app-overlay app-overlay--notification" *ngIf="showCancelConfirmDialog" (click)="onCancelConfirmBackdrop($event)">
  <div class="app-dialog app-dialog--notification" role="alertdialog" aria-modal="true" aria-labelledby="cancelConfirmHeading">
    <h2 id="cancelConfirmHeading" class="govuk-heading-m govuk-!-margin-bottom-2">Zatvoriť správu</h2>
    <p class="govuk-body">Chcete zatvoriť túto správu? Rozpracovaná správa bude uložená do konceptov a môžete ju neskôr upraviť.</p>

    <div class="app-actions govuk-!-margin-top-4">
      <button type="button" class="govuk-button govuk-button--secondary" (click)="confirmCancel()">
        Áno, zatvoriť
      </button>
      <button type="button" class="govuk-button" autofocus (click)="dismissCancelConfirm()">
        Nie, pokračovať v úpravách
      </button>
    </div>
  </div>
</div>

<!-- Delete confirmation dialog -->
<div class="app-overlay app-overlay--notification" *ngIf="showDeleteConfirmDialog" (click)="onDeleteConfirmBackdrop($event)">
  <div class="app-dialog app-dialog--notification" role="alertdialog" aria-modal="true" aria-labelledby="deleteConfirmHeading">
    <h2 id="deleteConfirmHeading" class="govuk-heading-m govuk-!-margin-bottom-2">Vymazať koncept</h2>
    <p class="govuk-body">Naozaj chcete vymazať túto rozpracovanú správu? Táto akcia je nevratná a všetky údaje budú permanentne odstránené.</p>

    <div class="app-actions govuk-!-margin-top-4">
      <button type="button" class="govuk-button govuk-button--warning" (click)="confirmDeleteDraft()">
        Áno, vymazať
      </button>
      <button type="button" class="govuk-button govuk-button--secondary" autofocus (click)="dismissDeleteConfirm()">
        Zrušiť
      </button>
    </div>
  </div>
</div>

<!-- Remove Signature Confirmation Dialog -->
<div class="app-overlay" *ngIf="showRemoveSignatureDialog" (click)="onRemoveSignatureBackdrop($event)">
  <div class="app-dialog app-dialog--notification" role="alertdialog" aria-modal="true" aria-labelledby="removeSignatureHeading">
    <h2 id="removeSignatureHeading" class="govuk-heading-m govuk-!-margin-bottom-2">Odstrániť podpis</h2>
    <p class="govuk-body">Vyberte dokumenty, z ktorých chcete odstrániť podpis. Pred odoslaním ich budete musieť znova podpísať.</p>

    <label class="app-sign-inline-label govuk-!-margin-bottom-2" *ngIf="unsignOptions.length > 1">
      <input type="checkbox" class="app-sign-checkbox"
             [checked]="allUnsignSelected"
             [indeterminate]="someUnsignSelected && !allUnsignSelected"
             (change)="toggleUnsignAll($any($event.target).checked)">
      <strong>Odstrániť všetky podpisy</strong>
    </label>

    <div *ngFor="let o of unsignOptions" class="govuk-!-margin-bottom-1">
      <label class="app-sign-inline-label">
        <input type="checkbox" class="app-sign-checkbox"
               [(ngModel)]="o.selected" [ngModelOptions]="{ standalone: true }">
        {{ o.label }}
      </label>
    </div>

    <div class="app-actions govuk-!-margin-top-4">
      <button type="button" class="govuk-button govuk-button--warning"
              (click)="confirmRemoveSignature()"
              [disabled]="unsignSelectedCount === 0">
        {{ allUnsignSelected ? 'Odstrániť všetky podpisy' : 'Odstrániť vybrané podpisy' }}
      </button>
      <button type="button" class="govuk-button govuk-button--secondary" autofocus (click)="dismissRemoveSignatureConfirm()">
        Zrušiť
      </button>
    </div>
  </div>
</div>

<!-- TESTING PANEL - Only visible in development -->
<div *ngIf="showTestPanel()" class="test-panel">
  <h3 class="test-panel__title">🧪 WebSocket Test Panel</h3>
  <div class="test-panel__info">
    <div>WS Status: <span [ngClass]="wsConnected() ? 'ws-status--connected' : 'ws-status--disconnected'">{{ wsConnected() ? '✅ Connected' : '❌ Disconnected' }}</span></div>
    <div>Listening: <span [ngClass]="signingInProgress() ? 'ws-status--listening' : 'ws-status--not-listening'">{{ signingInProgress() ? '✅ Yes' : '⏸️ No' }}</span></div>
    <div *ngIf="currentJobId">JobID: <code class="test-panel__job-id">{{ currentJobId }}</code></div>
    <div *ngIf="!currentJobId" class="ws-status--inactive">No active job</div>
  </div>
  <div *ngIf="currentJobId" class="test-panel__actions">
    <div *ngIf="deeplink && !signingInProgress()" class="test-panel__hint">
      💡 Click "Podpísať" first, or use test buttons below
    </div>
    <button (click)="testSigningSuccess()" class="test-panel__button test-panel__button--success">
      ✅ Simulate SUCCESS
    </button>
    <button (click)="testSigningFailed()" class="test-panel__button test-panel__button--failed">
      ❌ Simulate FAILURE
    </button>
    <button (click)="testSigningPending()" class="test-panel__button test-panel__button--pending">
      ⏳ Simulate PENDING
    </button>
  </div>
  <div *ngIf="!currentJobId" class="test-panel__no-job">
    Click "Podpísať" first
  </div>
</div>
